import { memo, useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Add } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import {
  VirtualizedMultiSelect,
  type MultiSelectOption,
} from '../../../components/VirtualizedMultiSelect/VirtualizedMultiSelect.jsx';

type Props = {
  options: MultiSelectOption[];
  isLoading: boolean;
  disabled: boolean;
  onAdd: (ids: string[]) => void;
};

const UsersPicker = memo(({ options, isLoading, disabled, onAdd }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  const [pendingIds, setPendingIds] = useState<string[]>([]);

  const handleAdd = () => {
    onAdd(pendingIds);
    setPendingIds([]);
  };

  return (
    <div className="flex flex-row items-end gap-1">
      <VirtualizedMultiSelect
        id="shared-folder-users"
        className="min-w-0 flex-1"
        placeholder={t('Add users')}
        groupLabel={t('Users')}
        options={options}
        value={pendingIds}
        onChange={setPendingIds}
        disabled={disabled}
        isLoading={isLoading}
        textLabels={{
          search: t('Search'),
          selectAll: t('Select all'),
          clearAll: t('Clear all'),
          empty: t('No users found'),
          loading: t('Loading'),
        }}
      />

      <Button
        variant="outlined"
        size="large"
        disabled={disabled || !pendingIds.length}
        data-dd-action-name="Knowledge base: add users to shared folder"
        onClick={handleAdd}
      >
        <Add />
        {t('Add')}
      </Button>
    </div>
  );
});

export { UsersPicker };
